export const loaderWithBackdropWrapper = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.3)',
  backdropFilter: 'blur(4px)',
  zIndex: 10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
